// extracted by mini-css-extract-plugin
export default {"container":"ShortText_container__Jr1HO"};